module.exports = "<ng-content></ng-content>\r\n<span class=\"help-block text-danger small\" *ngIf=\"errorMessage\">\r\n  {{errorMessage}}\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/visbos-core/ui/forms/directives/form-control-message/form-control-message.component.html
// module id = ./src/app/core/visbos-core/ui/forms/directives/form-control-message/form-control-message.component.html
// module chunks = main